// @core/api/endpoints/tag/list_tagged_entities.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTaggedEntitiesResponse,
} from '../../../types/tag';

const BASE_PATH = '/tag';

/**
 * List entities with tag
 * Returns all entities that have a specific tag assigned. Supports filtering by entity type and product. Returns lightweight resource previews.
 */
export async function ListTaggedEntities(
  tag_id: string,
  params?: {
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    entity_type?: string | number | boolean;
    limit?: string | number | boolean;
    product_id?: string | number | boolean;
    sort?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListTaggedEntitiesResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tags/:tag_id/entities`;
  requestPath = requestPath.replace(':tag_id', encodeURIComponent(tag_id));
  const requestOptions = options;
  return client.get<ListTaggedEntitiesResponse>(requestPath, { ...requestOptions, params });
}
